// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// Main page scroll restoration (issue #512) – run first so it works even if a require() fails below.
// Chrome + Firefox (Firefox: localStorage backup, pageshow delayed, visibilitychange).
(function() {
  var SCROLL_POSITION_KEY = 'scrollPosition';
  var LOG = function() { try { console.log.apply(console, ['[scroll-restore]'].concat(Array.prototype.slice.call(arguments))); } catch (e) {} };
  function isMainPage() { var p = (window.location.pathname || ''); return p === '/' || p === ''; }
  function isAdDetailPath(pathname) {
    if (!pathname || pathname === '/') return false;
    var seg = (pathname.replace(/^\/|\/$/g, '') || '').split('/');
    return seg.length === 4 && /^\d+$/.test(seg[3]);
  }
  function getStoredScroll() {
    try {
      var s = (typeof sessionStorage !== 'undefined' && sessionStorage.getItem(SCROLL_POSITION_KEY)) ||
              (typeof localStorage !== 'undefined' && localStorage.getItem(SCROLL_POSITION_KEY));
      return s || null;
    } catch (e) { return null; }
  }
  function doRestore() {
    if (!isMainPage()) return;
    try {
      var stored = getStoredScroll();
      if (!stored) return;
      var y = parseInt(stored, 10);
      if (!isFinite(y) || y < 0) return;
      LOG('doRestore scrollTo y=', y);
      window.scrollTo(0, y);
      if (document.documentElement) document.documentElement.scrollTop = y;
      if (document.body) document.body.scrollTop = y;
    } catch (e) { LOG('doRestore error', e); }
  }
  function runRestoreSequence(from) {
    LOG('runRestoreSequence from=', from);
    if (!isMainPage()) return;
    var stored = getStoredScroll();
    LOG('hasStored=', !!stored, 'value=', stored);
    doRestore();
    setTimeout(doRestore, 50);
    setTimeout(doRestore, 150);
    setTimeout(doRestore, 300);
    setTimeout(doRestore, 500);
    setTimeout(function() {
      try {
        sessionStorage.removeItem(SCROLL_POSITION_KEY);
        localStorage.removeItem(SCROLL_POSITION_KEY);
        LOG('cleared');
      } catch (e) {}
    }, 700);
  }
  if (isMainPage() && typeof history !== 'undefined' && 'scrollRestoration' in history) {
    try { history.scrollRestoration = 'manual'; } catch (e) {}
  }
  function saveScroll() {
    var y = String(window.scrollY);
    try { sessionStorage.setItem(SCROLL_POSITION_KEY, y); } catch (e) {}
    try { localStorage.setItem(SCROLL_POSITION_KEY, y); } catch (e) {}
    LOG('SAVED scrollY=', window.scrollY);
  }
  document.addEventListener('click', function(e) {
    var link = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!link || !link.href || link.target === '_blank' || link.getAttribute('rel') === 'external') return;
    if (!isMainPage()) return;
    try {
      var href = link.getAttribute('href');
      if (!href || href.indexOf('#') === 0 || href.indexOf('javascript:') === 0) return;
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      if (!isAdDetailPath(url.pathname)) return;
      saveScroll();
    } catch (err) { LOG('click error', err); }
  }, true);
  window.addEventListener('pagehide', function() {
    if (isMainPage()) saveScroll();
  });
  window.addEventListener('load', function() { LOG('load'); runRestoreSequence('load'); });
  window.addEventListener('pageshow', function(ev) {
    LOG('pageshow persisted=', ev.persisted, 'hasKey=', !!getStoredScroll());
    if (!isMainPage()) return;
    if (!getStoredScroll()) return;
    runRestoreSequence('pageshow');
    // Firefox bfcache: run again after a short delay so layout is ready.
    if (ev.persisted) {
      setTimeout(function() { runRestoreSequence('pageshow-delayed'); }, 50);
      setTimeout(function() { runRestoreSequence('pageshow-delayed2'); }, 200);
    }
  });
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible' && isMainPage() && getStoredScroll()) runRestoreSequence('visibilitychange');
  });
})();

require("cocoon")
require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require('jquery')
require('bootstrap')
require('website/bootstrap-select.min')
require('website/jquery-ui-1.10.1.custom.min')
require('website/jquery.jscroll')
require('website/jquery.timepicker.min')
import I18n from 'i18n-js'
window.I18n = I18n
require('i18n/translations')
// require('website/jquery.keyboard')
require('bootstrap-datepicker')
require('front/auction')
require('website/maps')
require("packs/select2setup")
require('website/acommon')
require('channels/auction_channel')

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
// Support component names relative to this directory:
// var componentRequireContext = require.context("components", true);
// var ReactRailsUJS = require("react_ujs");
// ReactRailsUJS.useContext(componentRequireContext);

require("trix")
require("@rails/actiontext")

// Ensure login modal opens when LOGIN button is clicked (Bootstrap 5; works with Turbolinks).
(function() {
  function openLoginModal(e) {
    var trigger = e.target.closest('[data-bs-target="#loginModal"]');
    if (!trigger) return;
    var el = document.getElementById('loginModal');
    if (!el || typeof bootstrap === 'undefined') return;
    e.preventDefault();
    var modal = bootstrap.Modal.getOrCreateInstance(el);
    modal.show();
  }

  document.addEventListener('click', openLoginModal, true);
})();

// Footer is always visible (no scroll-based show/hide)